export const TIMEZONE = 'Europe/Moscow'
// export const TIMEZONE = 'America/Los_Angeles'
export const COMPLETION_PERC = 80

export default {
  TIMEZONE,
  COMPLETION_PERC
}
